import { Loadable } from "common/Loadable";
import { Navbar, NavbarGroup, NavbarTitle } from "common/Navbar";
import { rideReportActions, rideReportSelectors } from "data/resources/rideReports";
import { ShowPageContainer } from "features/ride_reports/ShowPage";
import { formatDate } from "features/ride_reports/ShowPage/Nav";
import { featureNames, Msg } from "lib/localization";
import { softError } from "lib/softError";
import React, { useEffect } from "react";
import { FormattedMessage as T, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Link, useLocation, withRouter } from "react-router-dom";
import { sharedMessages } from "../intlMessages";
import styles from "./Article.scss";

const getTypeFromPath = (path) => {
  const m = path?.match(/\/(.*)\//);
  return m && m.pop();
};

// render me on the page if you want to scroll to the top of page on route transistions!
// this is a candidate to pull into a more general place, but
// in general we don't have that many pages that
// 1. render links to other instances of themselves (ie between journal articles), and
// 2. scroll
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

class _JournalArticle extends React.PureComponent {
  render() {
    const { article, ...others } = this.props;

    return (
      <>
        <ShowPageContainer
          {...others}
          reportId={article.id}
          journalArticle
          OverwriteNav={<JournalNav article={article} />}
        />
        <ScrollToTop />
      </>
    );
  }
}

class _NewsArticle extends React.PureComponent {
  render() {
    const { article, ...others } = this.props;

    return (
      <>
        <ShowPageContainer {...others} reportId={article.id} newsArticle OverwriteNav={<NewsNav article={article} />} />
        <ScrollToTop />
      </>
    );
  }
}

const JournalNav = ({ article }) => (
  <Navbar>
    <NavbarGroup>
      <li>
        <NavbarTitle to="/journal">
          <Msg m={featureNames.journal} />
        </NavbarTitle>
      </li>
      <li>
        <T id="journalMessages.storyBy" defaultMessage="story by" />{" "}
        <Link href={article.authorUrl} className={styles.authorLink}>
          {article.authorByline}
        </Link>
      </li>
      <li className={styles.collapse}>{formatDate(article.publishedAt)}</li>
    </NavbarGroup>
  </Navbar>
);

const NewsNav = ({ article }) => (
  <Navbar>
    <NavbarGroup>
      <li>
        <NavbarTitle to="/news">
          <Msg m={featureNames.newsAndPress} />
        </NavbarTitle>
      </li>
      <li>
        <T id="newsMessages.postedBy" defaultMessage="posted by" /> Ride with GPS
      </li>
      <li className={styles.collapse}>{formatDate(article.publishedAt)}</li>
    </NavbarGroup>
  </Navbar>
);

const loadInitialData = ({ loadJournal, loadNews, match }) => {
  let action;
  switch (getTypeFromPath(match.path)) {
    case "journal":
      action = loadJournal;
      break;
    case "news":
      action = loadNews;
      break;
    default:
      softError("<Article /> only works with news/journal ride reports");
  }
  return Promise.all([action()]);
};

const LoadableArticle = (props) => (
  <Loadable
    {...props}
    component={getTypeFromPath(props.match?.path) === "journal" ? _JournalArticle : _NewsArticle}
    loadingText={<Msg m={sharedMessages.loadingArticle} />}
    resourceLoaded={() => loadInitialData(props)}
  />
);

export const IntlArticle = injectIntl(LoadableArticle);

const mapStateToProps = (state, ownProps) => {
  const slug = ownProps.match.params.slug;
  const reportId = parseInt(slug, 10);

  return {
    article: rideReportSelectors.find(state, reportId),
  };
};

export const Article = withRouter(
  connect(mapStateToProps, {
    loadJournal: rideReportActions.journal,
    loadNews: rideReportActions.news,
  })(IntlArticle)
);
